import { render, staticRenderFns } from "./VSelectTarifa.vue?vue&type=template&id=e6732d6e&scoped=true&"
import script from "./VSelectTarifa.vue?vue&type=script&lang=js&"
export * from "./VSelectTarifa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6732d6e",
  null
  
)

export default component.exports